var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2.3999C13.5 1.57148 12.8284 0.899902 12 0.899902C11.1716 0.899902 10.5 1.57148 10.5 2.3999H13.5ZM12 23.9999L20.6603 8.9999H3.33975L12 23.9999ZM10.5 2.3999V10.4999H13.5V2.3999H10.5Z",
    fill: "#EB0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowArrow);
export default __webpack_public_path__ + "static/media/flow_arrow.677d666c3f7b06867e48f64929ca24bb.svg";
export { ForwardRef as ReactComponent };